export default class CreateSolutionError extends Error {

}
